import { closeModal, openModal } from "../../../js/components/modal";

let modalId;
let close_btn;

const onCloseBtnClick = (e) => {
  closeModal(e, modalId)
}
const init = () => {
  const modalWrapper = document.querySelector('div.modal-wrapper');
  console.log('modalWrapper1');
  console.log(modalWrapper);
  if (!modalWrapper) return;
  const modalContent = modalWrapper.querySelector('#modal-content');
  close_btn = document.querySelector('#modal-close-btn');
  if (close_btn) {
    close_btn.addEventListener('click', onCloseBtnClick);
    document.addEventListener('click', onCloseBtnClick);
  }
  if (modalContent && modalWrapper) {
    modalContent.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
    })
    modalId = modalWrapper.getAttribute('id');
    const isOpen = modalWrapper.getAttribute('data-initial-state');
    if (isOpen === 'true' && modalId) {
      openModal('', modalId);
    }
  }
}

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/templates/components/modal/modal.js